export const donorTraits:any = {
    pushiness: {
      0: "Passive; lets the fundraiser lead.",
      1: "Engaged but allows natural conversation flow.",
      2: "Occasionally restates priorities but stays flexible.",
      3: "Brings up priorities multiple times and expects them to be addressed.",
      4: "Actively redirects the conversation back to their interests.",
      5: "Very assertive; challenges fundraiser to meet their expectations."
    },
    receptiveness: {
      0: "Open to new ideas, trusts the fundraiser’s judgment.",
      1: "Mostly agreeable but asks occasional clarifying questions.",
      2: "Some hesitation; asks for supporting details.",
      3: "Frequently asks for proof or examples.",
      4: "Pushes back on key points and is hard to persuade.",
      5: "Highly skeptical; challenges most claims and requires strong justification."
    },
    riskTolerance: {
      0: "Prefers safe, proven investments with clear outcomes.",
      1: "Open to new ideas but favors well-established programs.",
      2: "Will consider some risk but prefers detailed plans.",
      3: "Comfortable with moderate risk if the impact is compelling.",
      4: "Willing to take risks if the vision aligns with their goals.",
      5: "Bold and visionary; excited about high-risk, high-reward opportunities."
    },
    timeSensitivity: {
      0: "Long-term thinker; comfortable with extended discussions.",
      1: "Willing to engage over time but not in a rush.",
      2: "Prefers a timely process but won’t push for speed.",
      3: "Wants a clear path forward but open to some back-and-forth.",
      4: "Expects quick responses and decisions.",
      5: "Highly urgent; wants clear answers and next steps immediately."
    }
  };